import { render, staticRenderFns } from "./ComplaintCreationFirstStepForm.vue?vue&type=template&id=5b4d61dc&scoped=true&lang=pug&"
import script from "./ComplaintCreationFirstStepForm.vue?vue&type=script&lang=ts&"
export * from "./ComplaintCreationFirstStepForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintCreationFirstStepForm.vue?vue&type=style&index=0&id=5b4d61dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d61dc",
  null
  
)

export default component.exports